import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRunShortcut: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconRunShortcut"><Path fillRule="evenodd" clipRule="evenodd" d="M21 3H3V21H21V3ZM15.3416 7.55279L13.5528 6.65836L8.65836 16.4472L10.4472 17.3416L15.3416 7.55279Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRunShortcut;
